import React, { useEffect, useState } from 'react'
import TopBar from '../../Components/SystemAdmin/TopBar'
import SideBar from '../../Components/SystemAdmin/SideBar'
import Main from '../../Components/SystemAdmin/Main'
import { getUserInfoSync } from '../../config/api'

const SysAdminDashboard = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const userInfo = getUserInfoSync()
  const isFirstLogin = userInfo?.first_login === true
  const [activeScreen, setActiveScreen] = useState(isFirstLogin ? 'profile' : 'create-company')

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle)
  }

  useEffect(() => {
    if (sidebarToggle) {
      document.body.classList.add('toggle-sidebar')
    } else {
      document.body.classList.remove('toggle-sidebar')
    }
  }, [sidebarToggle])

  // Force profile screen if first login
  useEffect(() => {
    if (isFirstLogin && activeScreen !== 'profile') {
      setActiveScreen('profile')
    }
  }, [isFirstLogin, activeScreen])

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    const initBootstrap = () => {
      if (window.bootstrap && window.bootstrap.Collapse) {
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(element => {
          // eslint-disable-next-line no-new
          new window.bootstrap.Collapse(element, { toggle: false })
        })
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBootstrap)
    } else {
      initBootstrap()
    }
  }, [activeScreen])

  return (
   <>
   <TopBar onToggleSidebar={handleSidebarToggle} setActiveScreen={setActiveScreen}/>
   <SideBar activeScreen={activeScreen} setActiveScreen={setActiveScreen} isFirstLogin={isFirstLogin}/>
   <Main activeScreen={activeScreen} setActiveScreen={setActiveScreen} isFirstLogin={isFirstLogin}/>
   </>
  )
}

export default SysAdminDashboard